export const WORDS = 2;
export const PICKTOW_PHONE = '(71)4042-1162';
